import React from "react";

/**
 * One header layout for every section: optional eyebrow, title, lead.
 * The boxed index works like a note number on a drawing sheet.
 *
 * @param {{ index?: string, eyebrow?: string, title: React.ReactNode, lead?: React.ReactNode,
 *           as?: string, align?: "split" | "center", tone?: "ink" | "paper", className?: string }} props
 */
export default function SectionHead({ index, eyebrow, title, lead, as: Title = "h2", align = "split", tone = "ink", className = "" }) {
    return (
        <header className={`section-head section-head--${align} section-head--${tone} ${className}`} data-aos="fade-up">
            <div className="section-head-main">
                {eyebrow && (
                    <p className="eyebrow">
                        {index && <span className="eyebrow-index">{index}</span>}
                        <span>{eyebrow}</span>
                    </p>
                )}
                <Title className="section-head-title">{title}</Title>
            </div>
            {lead && <p className="section-head-lead">{lead}</p>}
        </header>
    );
}
